// extracted by mini-css-extract-plugin
export default {"SearchForm":"SearchForm_SearchForm__9H0tr","searchBtn":"SearchForm_searchBtn__2KADF"};